<template>
  <div>
    <div class="page-title">新增作業</div>
    <div class="page-box">
      <jobFrom :formLabelAlign="formLabelAlign" ref="form"></jobFrom>
      <div class="page-button">
        <!-- 按钮文字动态切换 -->
        <el-button
            type="info"
            @click="onSubmit"
            :loading="submitting"
            :disabled="submitting"
        >
          {{ submitting ? "提交中..." : "提交" }}
        </el-button>
        <el-button type="success" @click="backIndexPage">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addHomeworks } from '@/api/homeworks'
import jobFrom from "./components/jobFrom.vue";
import moment from "moment";

export default {
  components: { jobFrom },
  data() {
    return {
      submitting: false, // 防重复提交
      formLabelAlign: {
        number: null,
        lang: 0,
        gradeId: 1,
        grade: {
          name: null,
          price: null,
        },
        startDate: moment().format('YYYY-MM-DD'),
        endDate: null,
        passScore: 0,
        homeworkScopes: [],
        students: [],
      },
    };
  },
  methods: {
    onSubmit() {
      if (this.submitting) return;
      this.$refs.form.$refs.form.validate((valid) => {
        if (valid) {
          this.addHomeworks();
        }
      });
    },
    async addHomeworks() {
      this.submitting = true; // 开始提交 → 显示提交中

      try {
        await addHomeworks(this.formLabelAlign);
        this.$message.success('新增成功');
        this.$router.push({ name: 'job' });
      } catch (err) {
        this.$message.error('提交失败，请重试');
      } finally {
        this.submitting = false; // 提交结束 → 恢复按钮
      }
    },
    backIndexPage() {
      this.$router.push('/job');
    }
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;
}
</style>